import { EventNames, TrackingEventTypes } from "@cinch-nx/shared-analytics";
export var handleTrackingClick = function(trackEvent, data) {
    trackEvent({
        eventName: data.eventName,
        type: TrackingEventTypes.ADOBE,
        data: {
            event: {
                name: EventNames.click,
                category: data.category,
                label: data.label,
                action: EventNames.click
            }
        }
    });
};
